import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import ActivityFeed from "../components/ActivityFeed";
import { Eye } from "lucide-react";

export default function DoagaIstoric() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/activity/doaga", { params: { limit: 1 } })
      .then((r) => setInfo(r.data))
      .catch((e) => setInfo({ error: e?.response?.data?.detail || "Eroare" }));
  }, []);

  return (
    <div className="max-w-4xl mx-auto pb-16" data-testid="doaga-istoric-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-gradient-to-br from-red-600 to-rose-700 text-white rounded-xl p-2.5 shadow">
          <Eye size={22} />
        </div>
        <div>
          <h1 className="font-display text-3xl font-bold">DOAGA ISTORIC</h1>
          <p className="text-sm text-zinc-500">
            Tot ce face în platformă angajatul <strong>{info?.person_name || "Doaga Alexandru-Ionuț"}</strong> — ore, combustibil, inventar/PSA, rapoarte, task-uri, saci, daune
          </p>
        </div>
      </div>

      {info?.error ? (
        <div className="text-sm text-red-600 border border-red-200 bg-red-50 rounded p-4" data-testid="doaga-error">{info.error}</div>
      ) : info && info.found === false ? (
        <div className="text-sm text-amber-700 border border-amber-200 bg-amber-50 rounded p-4" data-testid="doaga-not-found">
          Angajatul „Doaga" nu a fost găsit în această bază de date. Istoricul va apărea în producție, unde angajatul există.
        </div>
      ) : (
        <ActivityFeed endpoint="/activity/doaga" pageSize={30} />
      )}
    </div>
  );
}
